(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-sale"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const collectionSection = document.querySelector('section[data-section-type="collection"]');
    if (!collectionSection) return;

    const collectionNav = collectionSection.querySelector('nav.collection__nav');
    const collectionSidebar = collectionSection.querySelector('#filter-groups');
    const productsGrid = collectionSection.querySelector('[data-products-grid]');
    const filterToggle = collectionNav ? collectionNav.querySelector('button.popout__toggle[aria-controls="filter-groups"]') : null;
    const activeFiltersContainer = collectionNav.querySelector('.active-filters-container');
    const filterButtonsContainer = collectionNav.querySelector('.filter-buttons--container');

    if (!collectionNav || !collectionSidebar || !filterToggle || !activeFiltersContainer || !productsGrid) return;

    const activeFilterButtons = activeFiltersContainer ? activeFiltersContainer.querySelectorAll('.active-filter-button') : null;

    // Add event listeners to active filter buttons
    (function addActiveFilterButtonEventListeners() {
      if (activeFilterButtons) {
        activeFilterButtons.forEach(button => {
          button.addEventListener('click', () => {
            filterToggle.click();
            setTimeout(() => {
              const filterGroupElement = collectionSidebar.querySelector(`[data-filter-group="${button.dataset.filterGroup}"]`);
              const collapsible = filterGroupElement ? filterGroupElement.querySelector("[data-collapsible]") : null;
              const collapsibleTrigger = collapsible ? collapsible.querySelector("[data-collapsible-trigger]") : null;
              if (collapsible && collapsibleTrigger) {
                if (!collapsible.hasAttribute('open')) {
                  collapsibleTrigger.click();
                }
                filterGroupElement.scrollIntoView({ behavior: 'smooth' });
              }
            }, 300);
          });
        });
      }
    })();

    // Update active filter button counts
    function updateActiveFilterButtonCounts() {
      if (activeFilterButtons) {
        activeFilterButtons.forEach(button => {
          const filterGroup = button.dataset.filterGroup;
          const filterCount = collectionSidebar.querySelector(`[data-filter-group="${filterGroup}"]`).querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').length;
          if (filterCount > 0) {
            button.querySelector('.filter-count').textContent = filterCount;
            button.querySelector('.filter-count').classList.remove('hidden');
          } else {
            button.querySelector('.filter-count').textContent = '';
            button.querySelector('.filter-count').classList.add('hidden');
          }
        });
      }
    }

    // By default, open sidebar filter collapsibles that have active filters
    function openActiveCollapsibles() {
      const collapsibleTriggers = collectionSidebar.querySelectorAll('[data-collapsible-trigger]');
      collapsibleTriggers.forEach(trigger => {
        const filterGroup = trigger.closest('[data-filter-group]');
        const filterGroupInputs = filterGroup.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked');
        if (filterGroupInputs.length > 0) {
          trigger.click();
        }
      });
    };

    let smoothScrollExecuted = false;
    function smoothScrollFilterButtons() {
      if (filterButtonsContainer.scrollWidth > filterButtonsContainer.clientWidth) {
        const scrollDistance = filterButtonsContainer.scrollWidth - filterButtonsContainer.clientWidth;
        
        const startTime = performance.now();
        const initialDelay = 100; // 0.1 second delay before starting the scroll
        const scrollDuration = 2000; // 2 seconds for a slower initial scroll

        function smoothScroll(currentTime) {
          const elapsedTime = currentTime - startTime;
          if (elapsedTime < initialDelay) {
            requestAnimationFrame(smoothScroll);
            return;
          }

          const scrollTime = elapsedTime - initialDelay;
          if (scrollTime < scrollDuration) {
            const progress = scrollTime / scrollDuration;
            // Use a slower easing function for a more gradual start
            const easeInOutQuint = progress < 0.5
              ? 16 * progress * progress * progress * progress * progress
              : 1 - Math.pow(-2 * progress + 2, 5) / 2;
            filterButtonsContainer.scrollLeft = scrollDistance * easeInOutQuint;
            requestAnimationFrame(smoothScroll);
          } else {
            // Pause briefly at the end before scrolling back
            setTimeout(() => {
              const scrollBackDuration = 1000; // 1 second to scroll back
              const scrollBackStart = performance.now();

              function smoothScrollBack(currentTime) {
                const elapsedTime = currentTime - scrollBackStart;
                if (elapsedTime < scrollBackDuration) {
                  const progress = elapsedTime / scrollBackDuration;
                  const easeInOutCubic = progress < 0.5 
                    ? 4 * progress * progress * progress 
                    : 1 - Math.pow(-2 * progress + 2, 3) / 2;
                  filterButtonsContainer.scrollLeft = scrollDistance * (1 - easeInOutCubic);
                  requestAnimationFrame(smoothScrollBack);
                } else {
                  filterButtonsContainer.scrollLeft = 0;
                }
              }

              requestAnimationFrame(smoothScrollBack);
            }, 100); // 0.1 second pause at the end
          }
        }

        requestAnimationFrame(smoothScroll);
      }
    }

    // Function to update active filter buttons
    /*
    function updateActiveFilterButtons() {
      const activeFilters = {};
      const sidebarInputs = collectionSidebar.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked');

      // Collect active filters
      sidebarInputs.forEach(input => {
        const filterGroupElement = input.closest('[data-filter-group]');
        if (!filterGroupElement) return;
        const filterGroup = filterGroupElement.dataset.filterGroup;
        activeFilters[filterGroup] = (activeFilters[filterGroup] || 0) + 1;
      });

      // Create new active filter buttons
      Object.entries(activeFilters).forEach(([filterGroup, count]) => {
        const button = document.createElement('div');
        button.className = 'popout--group';
        button.innerHTML = `
          <button
            type="button"
            class="active-filter-button popout__toggle"
            data-filter-group="${filterGroup}"
          >
            ${filterGroup}
            <span class="filter-count">${count}</span>
          </button>
        `;
        activeFiltersContainer.appendChild(button);
        button.querySelector('button').addEventListener('click', () => {
          if (filterToggle) {
            filterToggle.click();
            setTimeout(() => {
              const filterGroupElement = collectionSidebar.querySelector(`[data-filter-group="${filterGroup}"]`);
              const collapsible = filterGroupElement ? filterGroupElement.querySelector("[data-collapsible]") : null;
              const collapsibleTrigger = collapsible ? collapsible.querySelector("[data-collapsible-trigger]") : null;
              if (collapsible && collapsibleTrigger) {
                if (!collapsible.hasAttribute('open')) {
                  collapsibleTrigger.click();
                }
                filterGroupElement.scrollIntoView({ behavior: 'smooth' });
              }
            }, 300);
          }
        });
      });

      // Update total active filters count
      const totalActiveFilters = Object.values(activeFilters).reduce((a, b) => a + b, 0);
      const filterCountElement = filterToggle.querySelector('.filter-count');
      if (filterCountElement) {
        if (totalActiveFilters > 0) {
          filterCountElement.textContent = totalActiveFilters;
          filterCountElement.classList.remove('hidden');
        } else {
          filterCountElement.textContent = '';
          filterCountElement.classList.add('hidden');
        }
      }
    }
    */

    // Function to clone active filters
    function cloneActiveFilters() {
      const originalActiveFilters = collectionSidebar.querySelector('.collection__active__filters');
      
      // Remove existing cloned filters
      const existingClone = collectionSection.querySelector('.collection__active__filters--clone');
      if (existingClone) {
        existingClone.remove();
      }

      // If there's no original active filters, we're done
      if (!originalActiveFilters) return;

      const clonedActiveFilters = originalActiveFilters.cloneNode(true);
      clonedActiveFilters.classList.add('collection__active__filters--clone');

      // Remove animation attributes
      clonedActiveFilters.removeAttribute('data-animation');
      clonedActiveFilters.removeAttribute('data-animation-delay');
      clonedActiveFilters.removeAttribute('data-animation-duration');

      // Insert the new clone as the first child of the products grid
      productsGrid.insertBefore(clonedActiveFilters, productsGrid.firstChild);

      // Add click event listeners to cloned filter removal buttons
      clonedActiveFilters.querySelectorAll('a.active__filters__remove').forEach(button => {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          const originalButton = originalActiveFilters.querySelector(`a[href="${this.getAttribute('href')}"]`);
          if (originalButton) {
            originalButton.click();
          }
        });
      });

      // Add click event listener to "Clear filters" button
      const clearFiltersButton = clonedActiveFilters.querySelector('a.active__filters__clear');
      if (clearFiltersButton) {
        clearFiltersButton.addEventListener('click', function(e) {
          e.preventDefault();
          const originalClearButton = originalActiveFilters.querySelector('a.active__filters__clear');
          if (originalClearButton) {
            originalClearButton.click();
          }
        });
      }
    }

    // Initial clone
    cloneActiveFilters();

    // Listen for filter updates
    collectionSection.addEventListener('theme:filter:update', () => {
      // updateActiveFilterButtons();
      updateActiveFilterButtonCounts();
      openActiveCollapsibles();
      cloneActiveFilters(); // Re-clone active filters
      smoothScrollFilterButtons();
      smoothScrollExecuted = true;
    });

    // Listen for scroll events (executed once)
    let isScrolling = false;
    document.addEventListener('scroll', () => {
      if (smoothScrollExecuted || isScrolling) return;
      
      const viewportHeight = window.innerHeight;
      const activeFiltersRect = activeFiltersContainer.getBoundingClientRect();
      const activeFiltersTop = activeFiltersRect.top;
      const activeFiltersBottom = activeFiltersRect.bottom;
      
      // Check if the active filters container is visible and in the bottom third of the viewport
      if (activeFiltersTop < viewportHeight && activeFiltersBottom > viewportHeight * 2/3) {
        isScrolling = true;
        smoothScrollFilterButtons();
        smoothScrollExecuted = true;
        
        // Wait for the scroll animation to finish before allowing new scroll events
        setTimeout(() => {
          isScrolling = false;
        }, 5000); // Adjust this timeout to match your smoothScrollActiveFilters duration
      }
    });

    // Initial update
    // updateActiveFilterButtons();
    openActiveCollapsibles();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const collectionSection = document.querySelector('section[data-section-type="collection"]');
    if (!collectionSection) return;

    const collectionNav = collectionSection.querySelector('nav.collection__nav');
    const collectionSidebar = collectionSection.querySelector('#filter-groups');
    const productsGrid = collectionSection.querySelector('[data-products-grid]');
    const filterToggle = collectionNav ? collectionNav.querySelector('button.popout__toggle[aria-controls="filter-groups"]') : null;
    const activeFiltersContainer = collectionNav.querySelector('.active-filters-container');
    const filterButtonsContainer = collectionNav.querySelector('.filter-buttons--container');

    if (!collectionNav || !collectionSidebar || !filterToggle || !activeFiltersContainer || !productsGrid) return;

    const activeFilterButtons = activeFiltersContainer ? activeFiltersContainer.querySelectorAll('.active-filter-button') : null;

    // Add event listeners to active filter buttons
    (function addActiveFilterButtonEventListeners() {
      if (activeFilterButtons) {
        activeFilterButtons.forEach(button => {
          button.addEventListener('click', () => {
            filterToggle.click();
            setTimeout(() => {
              const filterGroupElement = collectionSidebar.querySelector(`[data-filter-group="${button.dataset.filterGroup}"]`);
              const collapsible = filterGroupElement ? filterGroupElement.querySelector("[data-collapsible]") : null;
              const collapsibleTrigger = collapsible ? collapsible.querySelector("[data-collapsible-trigger]") : null;
              if (collapsible && collapsibleTrigger) {
                if (!collapsible.hasAttribute('open')) {
                  collapsibleTrigger.click();
                }
                filterGroupElement.scrollIntoView({ behavior: 'smooth' });
              }
            }, 300);
          });
        });
      }
    })();

    // Update active filter button counts
    function updateActiveFilterButtonCounts() {
      if (activeFilterButtons) {
        activeFilterButtons.forEach(button => {
          const filterGroup = button.dataset.filterGroup;
          const filterCount = collectionSidebar.querySelector(`[data-filter-group="${filterGroup}"]`).querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').length;
          if (filterCount > 0) {
            button.querySelector('.filter-count').textContent = filterCount;
            button.querySelector('.filter-count').classList.remove('hidden');
          } else {
            button.querySelector('.filter-count').textContent = '';
            button.querySelector('.filter-count').classList.add('hidden');
          }
        });
      }
    }

    // By default, open sidebar filter collapsibles that have active filters
    function openActiveCollapsibles() {
      const collapsibleTriggers = collectionSidebar.querySelectorAll('[data-collapsible-trigger]');
      collapsibleTriggers.forEach(trigger => {
        const filterGroup = trigger.closest('[data-filter-group]');
        const filterGroupInputs = filterGroup.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked');
        if (filterGroupInputs.length > 0) {
          trigger.click();
        }
      });
    };

    let smoothScrollExecuted = false;
    function smoothScrollFilterButtons() {
      if (filterButtonsContainer.scrollWidth > filterButtonsContainer.clientWidth) {
        const scrollDistance = filterButtonsContainer.scrollWidth - filterButtonsContainer.clientWidth;
        
        const startTime = performance.now();
        const initialDelay = 100; // 0.1 second delay before starting the scroll
        const scrollDuration = 2000; // 2 seconds for a slower initial scroll

        function smoothScroll(currentTime) {
          const elapsedTime = currentTime - startTime;
          if (elapsedTime < initialDelay) {
            requestAnimationFrame(smoothScroll);
            return;
          }

          const scrollTime = elapsedTime - initialDelay;
          if (scrollTime < scrollDuration) {
            const progress = scrollTime / scrollDuration;
            // Use a slower easing function for a more gradual start
            const easeInOutQuint = progress < 0.5
              ? 16 * progress * progress * progress * progress * progress
              : 1 - Math.pow(-2 * progress + 2, 5) / 2;
            filterButtonsContainer.scrollLeft = scrollDistance * easeInOutQuint;
            requestAnimationFrame(smoothScroll);
          } else {
            // Pause briefly at the end before scrolling back
            setTimeout(() => {
              const scrollBackDuration = 1000; // 1 second to scroll back
              const scrollBackStart = performance.now();

              function smoothScrollBack(currentTime) {
                const elapsedTime = currentTime - scrollBackStart;
                if (elapsedTime < scrollBackDuration) {
                  const progress = elapsedTime / scrollBackDuration;
                  const easeInOutCubic = progress < 0.5 
                    ? 4 * progress * progress * progress 
                    : 1 - Math.pow(-2 * progress + 2, 3) / 2;
                  filterButtonsContainer.scrollLeft = scrollDistance * (1 - easeInOutCubic);
                  requestAnimationFrame(smoothScrollBack);
                } else {
                  filterButtonsContainer.scrollLeft = 0;
                }
              }

              requestAnimationFrame(smoothScrollBack);
            }, 100); // 0.1 second pause at the end
          }
        }

        requestAnimationFrame(smoothScroll);
      }
    }

    // Function to update active filter buttons
    /*
    function updateActiveFilterButtons() {
      const activeFilters = {};
      const sidebarInputs = collectionSidebar.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked');

      // Collect active filters
      sidebarInputs.forEach(input => {
        const filterGroupElement = input.closest('[data-filter-group]');
        if (!filterGroupElement) return;
        const filterGroup = filterGroupElement.dataset.filterGroup;
        activeFilters[filterGroup] = (activeFilters[filterGroup] || 0) + 1;
      });

      // Create new active filter buttons
      Object.entries(activeFilters).forEach(([filterGroup, count]) => {
        const button = document.createElement('div');
        button.className = 'popout--group';
        button.innerHTML = `
          <button
            type="button"
            class="active-filter-button popout__toggle"
            data-filter-group="${filterGroup}"
          >
            ${filterGroup}
            <span class="filter-count">${count}</span>
          </button>
        `;
        activeFiltersContainer.appendChild(button);
        button.querySelector('button').addEventListener('click', () => {
          if (filterToggle) {
            filterToggle.click();
            setTimeout(() => {
              const filterGroupElement = collectionSidebar.querySelector(`[data-filter-group="${filterGroup}"]`);
              const collapsible = filterGroupElement ? filterGroupElement.querySelector("[data-collapsible]") : null;
              const collapsibleTrigger = collapsible ? collapsible.querySelector("[data-collapsible-trigger]") : null;
              if (collapsible && collapsibleTrigger) {
                if (!collapsible.hasAttribute('open')) {
                  collapsibleTrigger.click();
                }
                filterGroupElement.scrollIntoView({ behavior: 'smooth' });
              }
            }, 300);
          }
        });
      });

      // Update total active filters count
      const totalActiveFilters = Object.values(activeFilters).reduce((a, b) => a + b, 0);
      const filterCountElement = filterToggle.querySelector('.filter-count');
      if (filterCountElement) {
        if (totalActiveFilters > 0) {
          filterCountElement.textContent = totalActiveFilters;
          filterCountElement.classList.remove('hidden');
        } else {
          filterCountElement.textContent = '';
          filterCountElement.classList.add('hidden');
        }
      }
    }
    */

    // Function to clone active filters
    function cloneActiveFilters() {
      const originalActiveFilters = collectionSidebar.querySelector('.collection__active__filters');
      
      // Remove existing cloned filters
      const existingClone = collectionSection.querySelector('.collection__active__filters--clone');
      if (existingClone) {
        existingClone.remove();
      }

      // If there's no original active filters, we're done
      if (!originalActiveFilters) return;

      const clonedActiveFilters = originalActiveFilters.cloneNode(true);
      clonedActiveFilters.classList.add('collection__active__filters--clone');

      // Remove animation attributes
      clonedActiveFilters.removeAttribute('data-animation');
      clonedActiveFilters.removeAttribute('data-animation-delay');
      clonedActiveFilters.removeAttribute('data-animation-duration');

      // Insert the new clone as the first child of the products grid
      productsGrid.insertBefore(clonedActiveFilters, productsGrid.firstChild);

      // Add click event listeners to cloned filter removal buttons
      clonedActiveFilters.querySelectorAll('a.active__filters__remove').forEach(button => {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          const originalButton = originalActiveFilters.querySelector(`a[href="${this.getAttribute('href')}"]`);
          if (originalButton) {
            originalButton.click();
          }
        });
      });

      // Add click event listener to "Clear filters" button
      const clearFiltersButton = clonedActiveFilters.querySelector('a.active__filters__clear');
      if (clearFiltersButton) {
        clearFiltersButton.addEventListener('click', function(e) {
          e.preventDefault();
          const originalClearButton = originalActiveFilters.querySelector('a.active__filters__clear');
          if (originalClearButton) {
            originalClearButton.click();
          }
        });
      }
    }

    // Initial clone
    cloneActiveFilters();

    // Listen for filter updates
    collectionSection.addEventListener('theme:filter:update', () => {
      // updateActiveFilterButtons();
      updateActiveFilterButtonCounts();
      openActiveCollapsibles();
      cloneActiveFilters(); // Re-clone active filters
      smoothScrollFilterButtons();
      smoothScrollExecuted = true;
    });

    // Listen for scroll events (executed once)
    let isScrolling = false;
    document.addEventListener('scroll', () => {
      if (smoothScrollExecuted || isScrolling) return;
      
      const viewportHeight = window.innerHeight;
      const activeFiltersRect = activeFiltersContainer.getBoundingClientRect();
      const activeFiltersTop = activeFiltersRect.top;
      const activeFiltersBottom = activeFiltersRect.bottom;
      
      // Check if the active filters container is visible and in the bottom third of the viewport
      if (activeFiltersTop < viewportHeight && activeFiltersBottom > viewportHeight * 2/3) {
        isScrolling = true;
        smoothScrollFilterButtons();
        smoothScrollExecuted = true;
        
        // Wait for the scroll animation to finish before allowing new scroll events
        setTimeout(() => {
          isScrolling = false;
        }, 5000); // Adjust this timeout to match your smoothScrollActiveFilters duration
      }
    });

    // Initial update
    // updateActiveFilterButtons();
    openActiveCollapsibles();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-collections-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const collectionItems = document.querySelectorAll('.collection-item__content[data-custom-url]');
    const collectionSidebar = document.querySelector('#filter-groups');
    
    collectionItems.forEach(item => {
      item.addEventListener('click', handleCollectionItemClick);
    });

    function scrollToCollectionNav() {
      const collectionProductsSection = document.querySelector('section[data-section-type="collection"]');
      if (!collectionProductsSection) return;

      const collectionNav = collectionProductsSection.querySelector('nav[data-collection-nav]');
      const navHeight = collectionNav ? collectionNav.getBoundingClientRect().top + window.scrollY : 0;
      const stickyHeaderHeight = document.querySelector('[data-header-sticky]') ? 
        document.querySelector('[data-header-height]').offsetHeight : 0;
      
      window.scrollTo({
        top: navHeight - stickyHeaderHeight,
        behavior: 'smooth'
      });
    }

    function handleCollectionItemClick(event) {
      const customUrl = this.getAttribute('data-custom-url');
      const currentPath = window.location.pathname;

      if (customUrl && customUrl.includes(currentPath) && customUrl.includes('filter.')) {
        event.preventDefault();
        
        // Scroll before filter update
        scrollToCollectionNav();

        try {
          // Parse the URL and get only the pathname and search parts
          const urlObject = new URL(customUrl, window.location.origin);
          const relativeUrl = urlObject.pathname + urlObject.search;
          
          // Update filters directly through URL
          window.history.pushState(null, '', relativeUrl);
          
          // Create a new popstate event to trigger the filter update
          const popStateEvent = new PopStateEvent('popstate', {
            bubbles: true,
            cancelable: true
          });
          window.dispatchEvent(popStateEvent);
        } catch (e) {
          console.error('Error processing URL:', e);
        }
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
